/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useCallback } from 'react';
import RemarkComponent from 'src/containers/remarks-container/RemarkContainer';
import PropTypes from 'prop-types';
import { isProduction } from 'src/config/index';
import { withFormikDevtools } from 'formik-devtools-extension';
import RoutingUtil from 'src/utils/RoutingUtil';
import { Formik, Form } from 'formik';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router';
import { shallowEqual } from 'recompose';
import FormikInput from 'src/components/formik/FormikInput';
import FormikCreateSearchClear from 'src/components/formik/FormikCreateSearchClear';
import { REQUEST_STATUS } from 'src/constants/CommonConstants';
import { usePrevious } from 'src/utils/ReactHooksUtil';
import UserDropDown from 'src/business-components/UserDropDown';
import { includeStamp } from 'src/utils/StampUtils';
import { customerResetAction, customerUpsertAction } from './actions/CustomerActions';
import { CustomerYupSchema } from './CustomerPropTypes';
import { REGISTRATION_TYPES_LIST, GENDER_TYPES_LIST, MARITAL_TYPES_LIST } from 'src/containers/customer-container/CustomerConstants';
import FileContainer from '../files-container/FileContainer';
import FormikSelect from 'src/components/formik/FormikSelect';
import FormikDateTimePicker from 'src/components/formik/FormikDateTimePicker';
import FormikToggle from 'src/components/formik/FormikToggle';
import MastersDropDown from 'src/business-components/MastersDropDown';
import { MASTERS_TYPES } from 'src/containers/masters-container/MastersConstants';

const Render = (props) => {
    // DEV TOOL
    if (!isProduction()) {
        withFormikDevtools(props);
    }

    const {
        values,
        // errors,
        // touched,
        isSubmitting,
        onSearch,
        onClear,
        resetForm,
    } = props;

    return (
        <div>
            <div className="card">
                <div className="card-body">
                    <Form autoComplete="disabled">
                        <h5 className="card-title">Customer Basic Details</h5>
                        {/* <div className="form-row">
                            <div className="form-group col">
                                <FormikToggle
                                    name="active"
                                    offLabel="Close"
                                    onLabel="Open"
                                />
                            </div>
                        </div> */}
                        <div className="form-row">
                            <div className="form-group col-md-3">
                                <label>First Name</label>
                                <FormikInput
                                    name="firstName"
                                    type="text"
                                    className="form-control"
                                />
                            </div>
                            <div className="form-group col-md-3">
                                <label>Last Name</label>
                                <FormikInput
                                    name="lastName"
                                    type="text"
                                    className="form-control"
                                />
                            </div>
                            <div className="form-group col-md-3">
                                <label>Assigned Agent</label>
                                <UserDropDown
                                    name="referredBy"
                                    value={values.referredBy}
                                />
                            </div>
                            <div className="form-group col-md-3">
                                <label>DOB</label>
                                <FormikDateTimePicker
                                    name="DOB"
                                    value={values?.DOB || ''}
                                    className="form-control"
                                    disableClock
                                    format="dd-MM-y"
                                />
                            </div>
                            <div className="form-group col-md-3">
                                <label>Reg. type</label>
                                <FormikSelect
                                    items={REGISTRATION_TYPES_LIST}
                                    name="regType"
                                    className="form-control"
                                    // disabled={Boolean(values._id)}
                                />
                            </div>
                            {values.regType !== "COMPANY" && (
                                <>
                            <div className="form-group col-md-3">
                                <label>Father/Husband's Name</label>
                                <FormikInput
                                    name="FatherHusband"
                                    type="text"
                                    className="form-control"
                                />
                            </div>
                            <div className="form-group col-md-3">
                                <label>Mother's Name</label>
                                <FormikInput
                                    name="Mother"
                                    type="text"
                                    className="form-control"
                                />
                            </div>

                            <div className="form-group col-md-3">
                                <label>Education Qualification</label>
                                <MastersDropDown
                                    name="educationQualification"
                                    value={values?.educationQualification || ''}
                                    masterType={MASTERS_TYPES.EDUCATION_QUALIFICATION}
                                />
                            </div>
                        
                            <div className="form-group col-md-3">
                                <label>Gender</label>
                                <FormikSelect
                                    items={GENDER_TYPES_LIST}
                                    name="gender"
                                    className="form-control"
                                    // disabled={Boolean(values._id)}
                                />
                            </div>
                            <div className="form-group col-md-3">
                                <label>Marital Status</label>
                                <FormikSelect
                                    items={MARITAL_TYPES_LIST}
                                    name="maritalStatus"
                                    className="form-control"
                                    // disabled={Boolean(values._id)}
                                />
                            </div>
                            <div className="form-group col-md-3">
                                <label>No. of Dependent</label>
                                <FormikInput
                                    name="dependent"
                                    type="text"
                                    className="form-control"
                                />
                            </div>
                            </>
                            )}
                            <div className="form-group col-md-3">
                                <label>Customer Referred By</label>
                                 <FormikInput
                                    // placeholder="Customer Reffered By"
                                    name="cutomerReferredBy"
                                    type="text"
                                    className="form-control"
                                />
                            </div>
                        </div>
                        <div className="mt-3">
                            <h3>
                                Occupation Details
                            </h3>
                            <div className="form-row">
                                <div className="form-group col-md-3">
                                    <label>Occupation Type</label>
                                    <MastersDropDown
                                        name="occupationType"
                                        value={values?.occupationType || ''}
                                        masterType={MASTERS_TYPES.OCCUPATION}
                                    />
                                </div>
                                <div className="form-group col-md-3">
                                    <label>Company Name</label>
                                    <FormikInput
                                        name="company"
                                        type="text"
                                        className="form-control"
                                    />
                                </div>
                                <div className="form-group col-md-3">
                                    <label>Designation</label>
                                    <FormikInput
                                        name="designation"
                                        type="text"
                                        className="form-control"
                                    />
                                </div>
                                <div className="form-group col-md-3">
                                    <label>Occupation</label>
                                    <FormikInput
                                        name="occupation"
                                        type="text"
                                        className="form-control"
                                    />
                                </div>
                                <div className="form-group col-md-3">
                                    <label>Industry Type</label>
                                    <MastersDropDown
                                        name="industryType"
                                        value={values?.industryType || ''}
                                        masterType={MASTERS_TYPES.INDUSTRY_TYPE}
                                    />
                                </div>
                                <div className="form-group col-md-3">
                                    <label>Company Contact</label>
                                    <FormikInput
                                        name="companyContact"
                                        type="text"
                                        className="form-control"
                                    />
                                </div>
                                <div className="form-group col-md-12">
                                    <label>Company Address</label>
                                    <FormikInput
                                        name="companyAddress"
                                        type="text"
                                        className="form-control"
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="mt-3">
                            <h3>
                                Communication Details
                            </h3>
                            <div className="form-row">
                                <div className="form-group col-md-3">
                                    <label>Mobile 1</label>
                                    <FormikInput
                                        name="mobile1"
                                        type="text"
                                        className="form-control"
                                    />
                                </div>
                                <div className="form-group col-md-3">
                                    <label>Mobile 2</label>
                                    <FormikInput
                                        name="mobile2"
                                        type="text"
                                        className="form-control"
                                    />
                                </div>

                                <div className="form-group col-md-3">
                                    <label>Contact No</label>
                                    <FormikInput
                                        name="phone"
                                        type="text"
                                        className="form-control"
                                    />
                                </div>
                                <div className="form-group col-md-3">
                                    <label>Email 1</label>
                                    <FormikInput
                                        name="email1"
                                        type="text"
                                        className="form-control"
                                    />
                                </div>

                                <div className="form-group col-md-3">
                                    <label>Email 2</label>
                                    <FormikInput
                                        name="email2"
                                        type="text"
                                        className="form-control"
                                    />

                                </div>
                                {values.regType !== "COMPANY" && (   
                                    <>
                                <div className="form-group col-md-3">
                                    <label>House Ownership/Residence </label>
                                    <FormikInput
                                        name="houseOwnershipResidence"
                                        type="text"
                                        className="form-control"
                                    />
                                </div>

                                <div className="form-group col-md-12">
                                    <label>Present Address</label>
                                    <FormikInput
                                        name="presentAddress"
                                        type="text"
                                        className="form-control"
                                    />
                                </div>
                                <div className="form-group col-md-12">
                                    <label>Permanent Address</label>
                                    <FormikInput
                                        name="permanentAddress"
                                        type="text"
                                        className="form-control"
                                    />
                                </div>
                                </>
                                )}
                            </div>
                        </div>

                        <div className="mt-3">
                            <h3>
                                Financial & Bank Details
                            </h3>
                            <div className="form-row">
                                <div className="form-group col-md-3">
                                    <label>Account No</label>
                                    <FormikInput
                                        name="accountNo"
                                        type="text"
                                        className="form-control"
                                    />
                                </div>

                                <div className="form-group col-md-3">
                                    <label>Bank Name</label>
                                    <FormikInput
                                        name="bankName"
                                        type="text"
                                        className="form-control"
                                    />
                                </div>
                                <div className="form-group col-md-3">
                                    <label>Branch</label>
                                    <FormikInput
                                        name="branch"
                                        type="text"
                                        className="form-control"
                                    />
                                </div>
                                <div className="form-group col-md-3">
                                    <label>Earning Per Month</label>
                                    <FormikInput
                                        name="EarningPerMonth"
                                        type="text"
                                        className="form-control"
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="text-center py-4 mt-3">
                            <FormikCreateSearchClear
                                isSubmitting={isSubmitting}
                                isUpdate={Boolean(values._id)}
                                onSearch={onSearch}
                                onClear={onClear}
                                resetForm={resetForm}
                                values={values}
                                submitScope="master.customer_manager.manage.submit"
                                searchScope="master.customer_manager.manage.search"
                            />
                        </div>
                    </Form>
                </div>

                <div className="p-3">
                    <div className="form-group">
                        <RemarkComponent
                            title="Customer Remarks"
                            refId={values._id}
                            source="customers"
                        />
                    </div>

                    <FileContainer
                        className="mt-3"
                        refId={values._id}
                        source="customer"
                        title="Customer Files"
                    />
                </div>
            </div>

        </div>
    );
};

Render.propTypes = {
    isSubmitting: PropTypes.bool.isRequired,
    onSearch: PropTypes.func.isRequired,
    onClear: PropTypes.func.isRequired,
    resetForm: PropTypes.func.isRequired,
    values: PropTypes.shape({
        _id: PropTypes.string,
        lat: PropTypes.number,
        lng: PropTypes.number,
        referredBy: PropTypes.string,
    }).isRequired,
};

// setting submit button state after submitting
let setSubmitting = () => { };

const CustomerForm = () => {
    const history = useHistory();
    // REDUX
    const dispatch = useDispatch();
    const {
        currentRecord,
        upsertReqStatus,
    } = useSelector((state) => state.CustomerReducer, shallowEqual);

    // if current record changed or request status changed the enable submit
    usePrevious({
        currentRecord,
        upsertReqStatus,
    }, (prev) => {
        if (
            prev.currentRecord !== currentRecord
            || (upsertReqStatus && prev.upsertReqStatus !== upsertReqStatus && upsertReqStatus !== REQUEST_STATUS.PENDING)) {
            setSubmitting(false);
        }
    });

    const onSubmit = useCallback((
        values,
        formikUtils,
    ) => {
        ({ setSubmitting } = formikUtils);
        includeStamp(values);
        dispatch(customerUpsertAction(values));
    }, [
        dispatch,
    ]);

    const onSearch = useCallback(({
        firstName,
        lastName,
        phone,
        email,
        company,
        designation,
        active,
    }) => {
        history.push(RoutingUtil.customerSearch({
            firstName,
            lastName,
            phone,
            email,
            company,
            designation,
            active,
        }));
    }, [
        history,
    ]);

    const onClear = useCallback(() => {
        dispatch(customerResetAction());
    }, [
        dispatch,
    ]);

    return (
        <Formik
            onSubmit={onSubmit}
            onClear={onClear}
            enableReinitialize
            initialValues={currentRecord}
            validationSchema={CustomerYupSchema}
            onSearch={onSearch}
        >
            {(formikProps) => (
                <Render
                    onClear={onClear}
                    onSearch={onSearch}
                    {...formikProps}
                />
            )}
        </Formik>
    );
};

export default CustomerForm;
